import format from 'date-fns/format';

export const formatDate = (date) => {
  if (date !== '') {
    return format(date, "MM-DD-YYYY");
  }

  return null;
};
